<template>
    <div class="activity-card">
        <div class="activity-content">
            <div class="activity-message">
                <strong>{{ actorName }}</strong> kullanıcısı
                <strong>{{ visitorName }}</strong> kişisinden
                <span class="tags">{{ tagNames }}</span> etiketlerini kaldırdı.
            </div>
            <div class="activity-time">{{ formattedTime }}</div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";

export default {
    name: "VisitorTagRemoved",
    props: {
        activity: {
            type: Object,
            required: true,
        },
    },
    computed: {
        actorName() {
            return _.get(this.activity, "actorUser.name", "Bilinmeyen");
        },
        visitorName() {
            const visitor = _.get(this.activity, "refVisitor");
            if (_.isArray(visitor) && visitor.length > 0) {
                return visitor[0].fullname || visitor[0].email || "Bilinmeyen Kişi";
            }
            return (
                _.get(this.activity, "refVisitor.fullname") ||
                _.get(this.activity, "refVisitor.email") ||
                "Bilinmeyen Kişi"
            );
        },
        tagNames() {
            const payload = _.get(this.activity, "payload", {});
            if (payload.tagName) return payload.tagName;
            if (_.isArray(payload.tagNames) && payload.tagNames.length > 0) {
                return payload.tagNames.join(", ");
            }
            const tags = _.get(this.activity, "refTags", []);
            if (tags.length === 0) return "Etiketler";
            return tags.map((tag) => (_.isObject(tag) && tag.name ? tag.name : tag)).join(", ");
        },
        formattedTime() {
            return moment(this.activity.createdAt).format("DD.MM.YYYY HH:mm");
        },
    },
};
</script>

<style scoped>
.activity-card {
    padding: 12px 16px;
    border-bottom: 1px solid var(--color-border-default);
}

.activity-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.activity-message {
    font-size: 14px;
    line-height: 1.5;
    color: var(--color-text-default);
}

.tags {
    color: var(--color-danger);
    font-weight: 500;
}

.activity-time {
    font-size: 12px;
    color: var(--color-text-subtle);
}
</style>

